import React from "react";

export const DownCaretIcon = () => (
    <svg className="select-icon icon-dropdown" style={{width: '13px', height: '9px' }}>
        <use xlinkHref="#icon-dropdown"></use>
    </svg>
);

export const SearchIcon = () => (
    <svg style={{ width: '20px', height: '20px' }}>
        <use xlinkHref="#icon-search"></use>
    </svg>
);

export const CrossIcon = () => (
    <svg className="icon-close-small" style={{width: '13px', height: '13px' }}>
        <use xlinkHref="#icon-close-small"></use>
    </svg>
);

export const CrossIconSmall = () => (
    <svg className="icon-close-small" style={{width: '10px', height: '10px' }}>
        <use xlinkHref="#icon-close-small"></use>
    </svg>
);

export const DownloadIcon = () => (
    <svg className="icon-download u-color-blue" style={{width: '15px', height: '15px' }}>
        <use xlinkHref="#icon-download"></use>
    </svg>
);

export const LockIconSmall = () => (
    <svg className="icon-padlock-small" style={{width: "13px", height: "14px"}}>
        <use xlinkHref="#icon-padlock-small"></use>
    </svg>
);

export const SortIcon = () => (
    <svg className="icon-sort" style={{width: '12px', height: '13px'}}>
        <use xlinkHref="#icon-sort"></use>
    </svg>
);

export const PencilIcon = () => (
    <svg className="icon-edit-pencil" style={{width: '14px', height: '14px'}}>
        <use xlinkHref="#icon-edit-pencil"></use>
    </svg>
);

export const AddIcon = () => (
    <svg className="icon-add u-color-blue" style={{width: '12px', height: '12px'}}>
        <use xlinkHref="#icon-add"></use>
    </svg>
);